var React = require('react');

function Dial270 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M999.929 0L500 0C223.892 0 0 223.892 0 500C0 776.178 223.892 1000 500 1000C776.108 1000 1000 776.108 1000 500L999.929 0Z","fill":"currentColor"}));
}

Dial270.defaultProps = {"width":"1000","height":"1000","viewBox":"0 0 1000 1000","fill":"none"};

module.exports = Dial270;

Dial270.default = Dial270;
